export default __webpack_public_path__ + "static/media/smartBillManagementPic.99cd2c2f.png";